import React from "react";
import GastosForm from "../../components/GastosForm";
import Navbar from "../../components/Navbar";

const Gasto = () => {
  return (
    <div className="container">
      <Navbar />

      <GastosForm />
    </div>
  );
};

export default Gasto;
